import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { connectToMailNylas } from "@app/scene/settings/util/connectToNylas";
import useAnalytics from "@app/util/contexts/useAnalytics";

import messages from "./messages";
import styles from "./NylasConnect.module.scss";

interface Props {}

const NylasDisconnected: React.FC<Props> = () => {
  const intl = useIntl();
  const analytics = useAnalytics();

  const handleConnect = useCallback(() => {
    connectToMailNylas();
    analytics.clicked(["Let's Go"]);
  }, [analytics]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>{intl.formatMessage(messages.disconnectedEmailTitle)}</div>
      <div className={styles.subTitle}>
        {intl.formatMessage(messages.disconnectedEmailSubTitle)}
      </div>
      <div>
        <Button onClick={handleConnect} type="primary">
          {intl.formatMessage(messages.disconnectedEmailConnect)}
        </Button>
      </div>
    </div>
  );
};

export default NylasDisconnected;
